import { render, staticRenderFns } from "./raised_buttons.vue?vue&type=template&id=53539372&"
import script from "./raised_buttons.vue?vue&type=script&lang=js&"
export * from "./raised_buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports